import { useUiStore } from "../../stores/ui-store";
import { GuideStepper } from "./GuideStepper";
import { useRunProgress } from "./use-run-progress";

/**
 * The guided flow for the run on screen, owning its own reads.
 *
 * Deliberately a component rather than a hook called by `ResultsShell`. The
 * decision log and export receipts arrive asynchronously, and holding them in
 * the shell made every one of those reads re-render the whole results tree —
 * including while a person is clicking a tab. Keeping the state here means the
 * shell renders exactly as it did before the flow existed, and only this bar
 * updates when its own data lands.
 */
export function GuideBar() {
  const review = useUiStore((state) => state.review);
  const analysisKey = useUiStore((state) => state.analysis?.analysisKey ?? null);
  const { decisions, exported } = useRunProgress(review, analysisKey);

  return (
    <GuideStepper
      variant="bar"
      state={{
        filesLoaded: true,
        profileChosen: true,
        analysisPresent: true,
        decisions,
        exported
      }}
    />
  );
}
